{
  "printer": {
    "NO_PAPER": "The printer is out of paper",
    "OVERHEATED": "The printer is hot, wait a moment",
    "UNAVAILABLE": "The printer is not available",
    "UNKNOWN": "Printing failed, try again",
    "blocked": "The print window could not be opened. Allow pop-ups and try again"
  },
  "scanner": {
    "hint": "Point the camera at the QR code on the receipt",
    "cancel": "Cancel",
    "permissionDenied": "The camera cannot be used. Allow it in the settings or enter the number manually",
    "unavailable": "The camera is not available on this device",
    "unreadable": "The code could not be read, try again or enter the number manually",
    "title": "Scan receipt",
    "starting": "Opening the camera..."
  },
  "receipt": {
    "reference": "Transaction number",
    "quantity": "Quantity",
    "operation": "Operation type",
    "product": "Product",
    "purchase": "Purchase",
    "imageAlt": "Purchase receipt",
    "sale": "Sale"
  }
}
